import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";
import { isAppleSafari } from "../../../../../../../../../utils";
import { addUserAccount } from "../../../../../../../../Authorization/SocialAuth/connectSocialAcc";


const channel = isAppleSafari() ? window : new BroadcastChannel('connect');
class TwitterFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hashtag: '',
            handle: '',
            mentions: '',
            advanced: '',
            showError: false,
            handleError: false,
            mentionError: false,
            advanceError: false,
            loading: false,
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value, error: false, handleError: false, showError: false, mentionError: false, advanceError: false });
    }

    onSubmit = (connectAccountId) => {
        const { updateStep, selectedFilterId } = this.props;
        const { hashtag, handle, advanced, mentions } = this.state;
        if (selectedFilterId == 2 && hashtag.trim().length == 0) {
            this.setState({ error: true });
        } else if (selectedFilterId == 1 && handle.trim().length == 0) {
            this.setState({ handleError: true });
        } else if (selectedFilterId == 7 && mentions.trim().length == 0) {
            this.setState({ mentionError: true });
        }  else if (selectedFilterId == 5 && advanced.trim().length == 0) {
            this.setState({ advanceError: true });
        } else {
            var obj = {
                networkId: 1,
                filter: selectedFilterId,
                moderation: 0,
                excludeRetweet: 1,
                excludeReplies: 1,
                multiplePhoto: 1,
                authRequire: 0,
                accountId: connectAccountId ? connectAccountId : 0
            }
          
            if (selectedFilterId == 2) {
                obj['feedText'] = hashtag.split('#').join('')
            } else if (selectedFilterId == 1) {
                obj['feedText'] = handle.split('@').join('')
            } else if (selectedFilterId == 7) {
                obj['feedText'] = mentions;
            } else if (selectedFilterId == 5) {
                obj['feedText'] = advanced;
            }

            this.setState({ loading: true, error: false, handleError: false, mentionError: false, advanceError: false });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;

        if (type == "addFeed") {
            addUserAccount(networkId, data, (connectAccountId) => this.onSubmit(connectAccountId), localStorage.getItem('ownerId'));
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { hashtag, handle, mentions, advanced, error, handleError, loading } = this.state;
        const { selectedFilterId } = this.props;
       
        return (
            <div className="ob-feed-form-wrapper w-100">
                <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input">
                        <span className="hastag d-flex align-items-center">
                            <i className={`fas fa-${selectedFilterId == 2 ? 'hashtag' : selectedFilterId == 5 ? 'search' : "at"}`}></i>
                        </span>
                        <InputField name={`${selectedFilterId == 2 ? 'hashtag' : selectedFilterId == 1 ? "handle" : selectedFilterId == 7 ? "mentions" : selectedFilterId == 5 ? "advanced" : ""}`} placeholder={selectedFilterId == 2 ? "Enter hashtag here.." : selectedFilterId == 1 ? "Enter handle here.." : selectedFilterId == 7 ? "Enter mention here.." : selectedFilterId == 5 ? "Enter search query here.." : "Enter hashtag here.."} className="form-control p-3" value={selectedFilterId == 2 ? hashtag : selectedFilterId == 1 ? handle : selectedFilterId == 7 ? mentions : selectedFilterId == 5 ? advanced : hashtag} onChangeHandler={(e) => this.onChangeHandler(e)} />
                    </div>

                    {((error && selectedFilterId == 2) || (handleError && selectedFilterId == 1) || (handleError && selectedFilterId == 7) || (handleError && selectedFilterId == 5)) ? <span id="feedsfield1error" className="errorMessage required">This field is required</span> : null}
                </div>
                <div className="click-next d-flex align-items-center py-3 px-3 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 2 ? !hashtag.trim() : selectedFilterId == 1 ? !handle.trim() : selectedFilterId == 7 ? !mentions.trim() : selectedFilterId == 5 ? !advanced.trim() : !hashtag.trim()} />
                </div>
            </div>
        )
    }
}

export default TwitterFeed;